import {
  FaWrench,
  FaHammer,
  FaPaintRoller,
  FaBolt,
  FaTools,
  FaToilet,
  FaFaucet,
  FaShower,
  FaBath,
  FaSink,
  FaFire,
  FaSnowflake,
  FaThermometerHalf,
  FaWind,
  FaLeaf,
  FaBroom,
  FaTree,
  FaCut,
  FaCouch,
  FaDoorOpen,
  FaDoorClosed,
  FaKey,
  FaLock,
  FaShieldAlt,
  FaCamera,
  FaBell,
  FaPhone,
  FaTv,
  FaWifi,
  FaPlug,
  FaLightbulb,
  FaSolarPanel,
  FaHome,
  FaWarehouse,
  FaBuilding,
  FaTruck,
  FaDumpster,
  FaRecycle,
  FaTrash,
  FaBug,
  FaSpider,
  FaPaw,
  FaCrow,
  FaWater,
  FaTint,
  FaSwimmingPool,
  FaHotTub,
  FaWheelchair,
  FaParking,
  FaCar,
  FaGasPump,
  FaHardHat,
  FaUserTie,
  FaHandsHelping,
  FaClipboardList,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationTriangle,
} from "react-icons/fa";

import {
  MdPlumbing,
  MdElectricalServices,
  MdCarpenter,
  MdRoofing,
  MdYard,
  MdConstruction,
  MdCleaningServices,
  MdSecurity,
  MdGasMeter,
  MdWindow,
  MdDeck,
  MdFence,
  MdGarage,
  MdPool,
  MdOutdoorGrill,
  MdFoundation,
  MdHomeRepairService,
  MdHandyman,
} from "react-icons/md";

import {
  GiPaintBrush,
  GiWoodBeam,
  GiConcreteBag,
  GiBrickWall,
  GiStoneWall,
  GiMetalBar,
  GiGlassShot,
  GiVacuumCleaner,
  GiFloorPolisher,
  GiGardeningShears,
  GiWateringCan,
  GiFireplace,
  GiTap,
  GiDrippingTube,
  GiPipes,
} from "react-icons/gi";

// Comprehensive icon mapping for blue-collar home services
export const iconMap = {
  // Plumbing & Water
  FaWrench,
  FaFaucet,
  FaSink,
  FaToilet,
  FaShower,
  FaBath,
  FaWater,
  FaTint,
  MdPlumbing,
  GiTap,
  GiDrippingTube,
  GiPipes,

  // Electrical
  FaBolt,
  FaPlug,
  FaLightbulb,
  FaSolarPanel,
  FaTv,
  FaWifi,
  MdElectricalServices,

  // General Repairs & Tools
  FaTools,
  FaHammer,
  MdHandyman,
  MdHomeRepairService,
  MdConstruction,
  FaHardHat,

  // Painting & Finishing
  FaPaintRoller,
  GiPaintBrush,

  // Carpentry & Woodwork
  MdCarpenter,
  GiWoodBeam,

  // Roofing & Exterior
  MdRoofing,
  MdWindow,
  FaDoorOpen,
  FaDoorClosed,

  // HVAC & Climate Control
  FaFire,
  FaSnowflake,
  FaThermometerHalf,
  FaWind,
  MdGasMeter,
  GiFireplace,

  // Landscaping & Lawn Care
  FaTree,
  FaLeaf,
  MdYard,
  GiGardeningShears,
  GiWateringCan,
  FaCut,

  // Cleaning Services
  FaBroom,
  MdCleaningServices,
  GiVacuumCleaner,
  GiFloorPolisher,

  // Pest Control
  FaBug,
  FaSpider,
  FaPaw,
  FaCrow,

  // Security & Locks
  FaKey,
  FaLock,
  FaShieldAlt,
  FaCamera,
  FaBell,
  MdSecurity,

  // Flooring & Foundation
  MdFoundation,

  // Outdoor Structures
  MdDeck,
  MdFence,
  MdGarage,
  FaParking,
  MdOutdoorGrill,

  // Pool & Hot Tub
  FaSwimmingPool,
  FaHotTub,
  MdPool,

  // Moving & Hauling
  FaTruck,
  FaDumpster,
  FaRecycle,
  FaTrash,

  // Masonry & Concrete
  GiBrickWall,
  GiStoneWall,
  GiConcreteBag,

  // Metal & Glass Work
  GiMetalBar,
  GiGlassShot,

  // Accessibility
  FaWheelchair,

  // Property Types
  FaHome,
  FaBuilding,
  FaWarehouse,
  FaCouch,

  // Contact & Service
  FaPhone,
  FaUserTie,
  FaHandsHelping,
  FaClipboardList,

  // Status Indicators
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationTriangle,

  // Automotive
  FaCar,
  FaGasPump,
};

// Helper component to render icons dynamically
export const DynamicIcon = ({
  iconName,
  size = 24,
  color,
  className,
  style,
}) => {
  const IconComponent = iconMap[iconName];

  // Fallback to tools icon if icon not found
  if (!IconComponent) {
    return (
      <FaTools size={size} color={color} className={className} style={style} />
    );
  }

  return (
    <IconComponent
      size={size}
      color={color}
      className={className}
      style={style}
    />
  );
};

// Predefined category icon suggestions
export const categoryIconSuggestions = {
  // Plumbing & Water
  Plumbing: "MdPlumbing",
  Wrench: "FaWrench",
  Faucet: "FaFaucet",
  Sink: "FaSink",
  Toilet: "FaToilet",
  Shower: "FaShower",
  Bath: "FaBath",
  Water: "FaWater",
  Droplet: "FaTint",
  Tap: "GiTap",
  "Dripping Pipe": "GiDrippingTube",
  Pipes: "GiPipes",

  // Electrical
  "Electric Bolt": "FaBolt",
  "Electrical Services": "MdElectricalServices",
  Plug: "FaPlug",
  Lightbulb: "FaLightbulb",
  "Solar Panel": "FaSolarPanel",
  TV: "FaTv",
  WiFi: "FaWifi",

  // General Repairs & Tools
  Tools: "FaTools",
  Hammer: "FaHammer",
  Handyman: "MdHandyman",
  "Home Repair": "MdHomeRepairService",
  Construction: "MdConstruction",
  "Hard Hat": "FaHardHat",

  // Painting & Finishing
  "Paint Roller": "FaPaintRoller",
  "Paint Brush": "GiPaintBrush",

  // Carpentry & Woodwork
  Carpentry: "MdCarpenter",
  "Wood Beam": "GiWoodBeam",

  // Roofing & Exterior
  Roofing: "MdRoofing",
  "Windows & Doors": "MdWindow",
  "Door Open": "FaDoorOpen",
  "Door Closed": "FaDoorClosed",

  // HVAC & Climate Control
  HVAC: "FaSnowflake",
  Thermometer: "FaThermometerHalf",
  Fire: "FaFire",
  Wind: "FaWind",
  "Gas Meter": "MdGasMeter",
  Fireplace: "GiFireplace",

  // Landscaping & Lawn Care
  Landscaping: "MdYard",
  Tree: "FaTree",
  Leaf: "FaLeaf",
  "Gardening Shears": "GiGardeningShears",
  "Watering Can": "GiWateringCan",
  Trimmer: "FaCut",

  // Cleaning Services
  Cleaning: "MdCleaningServices",
  Broom: "FaBroom",
  "Vacuum Cleaner": "GiVacuumCleaner",
  "Floor Polisher": "GiFloorPolisher",

  // Pest Control
  "Pest Control": "FaBug",
  Spider: "FaSpider",
  Paw: "FaPaw",
  Crow: "FaCrow",

  // Security & Locks
  Security: "FaShieldAlt",
  Key: "FaKey",
  Lock: "FaLock",
  Camera: "FaCamera",
  Bell: "FaBell",
  "Security System": "MdSecurity",

  // Flooring & Foundation
  Foundation: "MdFoundation",

  // Outdoor Structures
  Deck: "MdDeck",
  Fencing: "MdFence",
  "Garage Door": "MdGarage",
  Parking: "FaParking",
  "Outdoor Grill": "MdOutdoorGrill",

  // Pool & Hot Tub
  "Swimming Pool": "FaSwimmingPool",
  "Hot Tub": "FaHotTub",
  Pool: "MdPool",

  // Moving & Hauling
  Moving: "FaTruck",
  Dumpster: "FaDumpster",
  Recycle: "FaRecycle",
  Trash: "FaTrash",

  // Masonry & Concrete
  "Brick Wall": "GiBrickWall",
  "Stone Wall": "GiStoneWall",
  Concrete: "GiConcreteBag",

  // Metal & Glass Work
  "Metal Bar": "GiMetalBar",
  Glass: "GiGlassShot",

  // Accessibility
  Wheelchair: "FaWheelchair",

  // Property Types
  Home: "FaHome",
  Building: "FaBuilding",
  Warehouse: "FaWarehouse",
  Furniture: "FaCouch",

  // Contact & Service
  Phone: "FaPhone",
  Professional: "FaUserTie",
  "Helping Hands": "FaHandsHelping",
  Clipboard: "FaClipboardList",

  // Status Indicators
  "Check Circle": "FaCheckCircle",
  "Times Circle": "FaTimesCircle",
  Warning: "FaExclamationTriangle",

  // Automotive
  Car: "FaCar",
  "Gas Pump": "FaGasPump",
};

export default DynamicIcon;
